import { Label } from "@radix-ui/react-label";
import React from "react";

const SurveyTitle: React.FC<{ title: string; description: string }> = (
  props,
) => {
  const { title, description } = props;

  return (
    <div className="m-2 flex flex-col">
      <Label className="text-normal font-semibold">Title:</Label>
      <Label className="text-medium font-normal">{title}</Label>
      <Label className="text-normal font-semibold">Description:</Label>
      <Label className="text-medium font-normal">{description}</Label>
    </div>
  );
};

export default SurveyTitle;
